export function plain2Tree (array, idName, parentIdName, childrenName, rootParentId) {
  const origin = JSON.parse(JSON.stringify(array))
  return origin.filter(parent => {
    const children = origin.filter(child => parent[idName] === child[parentIdName])
    if (children && children.length > 0) {
      parent[childrenName] = children
      parent.hasChildren = true
    }
    return parent[parentIdName] === rootParentId
  })
}

export function findByParentId (array, idName, parentIdName, parentId) {
  const origin = JSON.parse(JSON.stringify(array))
  return origin.filter(item => {
    return item[parentIdName] === parentId
  })
}
